import React from 'react';

const STEPS = [
	'Perfil',
	'Identificação',
	'Verificação',
	'Termos',
	'Confirmação',
	'Criação de Senha',
];

export default function OnboardingStepper({ current = 0 }) {
	return (
		<ol className="onboarding-stepper">
			{STEPS.map((label, index) => {
				const done = index < current;
				const active = index === current;
				const num = String(index + 1).padStart(2, '0');
				return (
					<li
						key={label}
						className={`onboarding-stepper__item${done ? ' is-done' : ''}${active ? ' is-active' : ''}`}
					>
						<span className="onboarding-stepper__marker" aria-hidden="true">
							{done ? (
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
									<path d="M2.5 7.2L5.4 10.1L11.5 3.5" stroke="#F6A900" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							) : (
								num
							)}
						</span>
						<span className="onboarding-stepper__label">{label}</span>
					</li>
				);
			})}
		</ol>
	);
}

export { STEPS as ONBOARDING_STEPS };
